// ProductSize__Elements [type="radio"] --> CLICK event -- START
$(document).on('click','.product-fitsmart-main.shirt .ProductSize__Elements [type="radio"]',function(){
  console.log("radio input click event",$(this));
  if($(this).hasClass('activeradio') && document.body.classList.contains("fitsmart-edit")){
    console.log("inside return for FALSE");
    return false;
  }
  if($(this).hasClass('activeradio')){
    $(this).removeClass('activeradio');
    $(this).closest('.ProductSize__Elements').removeClass('active');
    $(this).prop("checked", false);
  }else{
    $(this).prop("checked", true);
    $(this).closest('.ProductSize__Elements').find('input').removeClass('activeradio');
    $(this).addClass('activeradio');
    $(this).closest('.ProductSize__Elements').addClass('active');
  }
  $(this).closest('.ProductSize__Elements').find('.error').addClass('hide');
  if($(this).closest('.ProductSize__Elements').hasClass('ProductSize__BodyType')){
    var s_value = $(this).val();
    console.log("s_value",s_value);
    if(s_value == 'healthy'){
      var checkedShirtVal = $('.ProductSize__Elements.ProductSize__ShirtSize .activeradio[name="properties[_Shirt Size?]"]');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xs"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="s"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxxl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="4xl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="5xl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="6xl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="7xl"]').closest('.Property__Field').removeClass('hide');
      if (checkedShirtVal.length > 0){
        if (!checkedShirtVal.closest('.Property__Field').hasClass('hide')){
          $('.ProductSize__Elements.ProductSize__ShirtSize').addClass('active');
          $('.ProductSize__Elements.ProductSize__ShirtSize span.error').addClass('hide');
        }
      }
    }else if(s_value == 'average'){
      var checkedShirtVal = $('.ProductSize__Elements.ProductSize__ShirtSize .activeradio[name="properties[_Shirt Size?]"]');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xs"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="s"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxxl"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="4xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="5xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="6xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="7xl"]').closest('.Property__Field').addClass('hide');
      if (checkedShirtVal.length > 0){
        if (!checkedShirtVal.closest('.Property__Field').hasClass('hide')){
          $('.ProductSize__Elements.ProductSize__ShirtSize').addClass('active');
          $('.ProductSize__Elements.ProductSize__ShirtSize span.error').addClass('hide');
        }
      }
    }else if(s_value == 'athletic'){
      var checkedShirtVal = $('.ProductSize__Elements.ProductSize__ShirtSize .activeradio[name="properties[_Shirt Size?]"]');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xs"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="s"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="xxxl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="4xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="5xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="6xl"]').closest('.Property__Field').addClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"][value="7xl"]').closest('.Property__Field').addClass('hide');
      if (checkedShirtVal.length > 0){
        if (!checkedShirtVal.closest('.Property__Field').hasClass('hide')){
          $('.ProductSize__Elements.ProductSize__ShirtSize').addClass('active');
          $('.ProductSize__Elements.ProductSize__ShirtSize span.error').addClass('hide');
        }
      }
    }
    if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`) && !document.body.classList.contains("fitsmart-edit")){
      let getVal = document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`).value;
      let sizeTableN = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
      getVal = sizeTableN[getVal];
      console.log("getVal",getVal);
      let needToActionForSize = false;
      if(s_value == 'athletic'){
        if(getVal > 44){
          needToActionForSize = true;
        }
      }else if(s_value == 'average'){
        if(getVal > 48){	
          needToActionForSize = true;
        }
      }else if(s_value == 'healthy'){
        if(getVal < 40){
          needToActionForSize = true;
        }
      }
      console.log("needToActionForSize",needToActionForSize);
      if(needToActionForSize){
        document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`)?.classList.remove("activeradio");
        document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"].activeradio`)?.classList.remove("activeradio");
        if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Shirt Size?]"]:checked`).checked = false;
        
        document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`)?.classList.remove("activeradio");
        document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"].activeradio`)?.classList.remove("activeradio");
        if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`).checked = false;
      }
    }
  }  
  if($(this).closest('.ProductSize__Elements').hasClass('ProductSize__ShirtSize')){
    if($(this).val() == 'xxl' || $(this).val() == 'xxxl' || $(this).val() == '4xl' || $(this).val() == '5xl' || $(this).val() == '6xl' || $(this).val() == '7xl'){
      $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="SuperSlim"]').closest('.Property__Field').addClass('hide');
      var checkedPreferredVal = $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"]:checked').val();
      if(checkedPreferredVal == 'SuperSlim'){
        // setTimeout(() => {
          // $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Structured"]').click();
          document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`)?.classList.remove("activeradio");
          document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"].activeradio`)?.classList.remove("activeradio");
          if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Preferred Fit?]"]:checked`).checked = false;
        // },200);
      }
    }else{
      $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="SuperSlim"]').closest('.Property__Field').removeClass('hide');
    }
  }

  if($(this).closest(".Im-New-Filter").length > 0 && $(this).closest(".ProductSize__Elements").hasClass("ProductSize__BodyType")){
    console.log("bodytype radio found");
    // preffred fit size guide popup logic
    $(`.product-fitsmart-sizechart-item.fit-guide .ProductSize__ChartTable table`).addClass("hide");
    $(`.product-fitsmart-sizechart-item.fit-guide .ProductSize__ChartTable .${$(this).val()}`).removeClass("hide");
  }
  // fit value change
  if($('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"]:checked').length > 0 && $('.ProductSize__Elements.ProductSize__BodyType [name="properties[_Body Type?]"]:checked').length > 0){
    let measure = "in";
    if($(`.product-sizechart-tab.tab-fit-guide .sizechart-inch-cm-checkbox:checked`).length > 0){
      measure = "cm";
    }
    var bType = $('.ProductSize__Elements.ProductSize__BodyType [name="properties[_Body Type?]"]:checked').val();
    var selSize = $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"]:checked').val();
    tableUpdate(bType,selSize,measure);

    if(bType == 'healthy'){
      if(selSize == 'xxxl' || selSize == 'xxl' || selSize == '4xl' || selSize == '5xl' || selSize == '6xl' || selSize == '7xl'){
        $('.max_size').hide();
      }else{
        $('.max_size').show();
        // initFitsmartSliders();
      }
    }else if(bType == 'average'){
      if(selSize == 'xxxl' || selSize == 'xxl' || selSize == '4xl' || selSize == '5xl' || selSize == '6xl' || selSize == '7xl'){
        $('.max_size').hide();
      }else{
        $('.max_size').show();
        // initFitsmartSliders();
      }
    }
    
  }
  questionsCounter();
});
// ProductSize__Elements [type="radio"] --> CLICK event -- END

$(document).on("change",".product-fitsmart-sizechart-item.fit-guide .sizechart-inch-cm-checkbox",function(e){
  console.log("this",$(this));
  var measure = "in";
  if($(this).prop('checked')){
    measure = "cm";
  }
  var bType = $('.ProductSize__Elements.ProductSize__BodyType [name="properties[_Body Type?]"]:checked').val();
  var selSize = $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Shirt Size?]"]:checked').val();
  tableUpdate(bType,selSize,measure);
});

/* Goes to customise button if logged in from pdp page popup */
$(document).ready(function(){
  if(window.location.href.includes("/products")){
    const searchParams = new URLSearchParams(window.location.search);
    if(searchParams.has('cpid')){
      var loginOffset = $('.ProductForm__Size').offset().top || 0;
      $('html, body').animate({scrollTop: loginOffset - 115 }, 500);   
    }
  }
});

var checkoutURL = $('#customer_login').find('[name=checkout_url]');
if(checkoutURL.length){
  checkoutURL = checkoutURL.val();
  if(checkoutURL.indexOf('checkouts') > -1){
    $('#customer_login').find('[name=checkout_url]').val('/cart');
  }
}

$(document).ready(function(){

  // Get all the dropdown from document
  document.querySelectorAll('.dropdown-toggle').forEach(dropDownFunc);
  // Dropdown Open and Close function
  function dropDownFunc(dropDown) {
    console.log(dropDown.classList.contains('click-dropdown'));
    
    if(dropDown.classList.contains('click-dropdown') === true){
      dropDown.addEventListener('click', function (e) {
      e.preventDefault();
      
      if (this.nextElementSibling.classList.contains('dropdown-active') === true) {
      // Close the clicked dropdown
      this.parentElement.classList.remove('dropdown-open');
      this.nextElementSibling.classList.remove('dropdown-active');
      
      } else {
      // Close the opend dropdown
      closeDropdown();
      
      // add the open and active class(Opening the DropDown)
      this.parentElement.classList.add('dropdown-open');
      this.nextElementSibling.classList.add('dropdown-active');
      }
      });
    }
  };

  // Listen to the doc click
  window.addEventListener('click', function (e) {
    // Close the menu if click happen outside menu
    if (e.target.closest('.dropdown-container') === null) {
      // Close the opend dropdown
      closeDropdown();
    }
  });

  // Close the openend Dropdowns
  function closeDropdown() {
  
    // remove the open and active class from other opened Dropdown (Closing the opend DropDown)
    document.querySelectorAll('.dropdown-container').forEach(function (container) {
      container.classList.remove('dropdown-open');
    });
    
    document.querySelectorAll('.dropdown-menu').forEach(function (menu) {
      menu.classList.remove('dropdown-active');
    });
  }
  // close the dropdown on mouse out from the dropdown list
  document.querySelectorAll('.dropdown-menu').forEach(function (dropDownList) {
    // close the dropdown after user leave the list
    dropDownList.onmouseleave = closeDropdown;
  });  
                  
  if($('.AccountTable').length){
    if(order_data){
      var order_dataa = order_data.order_id;
      var order_allData = order_item_data;
      console.log('order_allData',order_allData);
      if($('.template-order').length > 0){
        var dr_html = '';
        $(order_allData).each(function(index,Items){
          var cartData_line_itemID  = Items.id;
          var cartData_properties  = Items.properties;
          var newgetgiftdata = [];
          var reacipentAttr;
          
          $(cartData_properties).each(function(index,Items){
          newgetgiftdata.push({ 'properties_name':Items[0], 'properties_value':Items[1],'item_id':cartData_line_itemID});
          });
          console.log("newgetgiftdata",newgetgiftdata);
          
          $(newgetgiftdata).each(function(index,Items){
            if(Items.properties_name == '_recipient_attributes' ){
              var getProductiedValue = Items.properties_value;
              if(getProductiedValue != '' && getProductiedValue != '[]'){
                $('.order_customDatadrawer[data-lineitemid='+cartData_line_itemID+']').removeClass('hide');
                var getnewarrydata = getProductiedValue.replaceAll('&quot;','"'); 
                reacipentAttr = JSON.parse(getnewarrydata);
              }else{
                $('.order_customDatadrawer[data-lineitemid='+cartData_line_itemID+']').addClass('hide');
              }
            }
          });
          
          $(document).on('click','.gift_card_drw .order_customDatadrawer',function(){
            console.log("order_customDatadrawer 274");        
            var cartItem_gift_title = $(this).closest('.order-outer').find('.cust-drw-btn').attr('data-gift-details');
            if(typeof cartItem_gift_title == "undefined"){
              $('.order-cust-detail .title').find('h3').text('Customisations');
            }else{
              $('.order-cust-detail .title').find('h3').text('Gift Card Details');
            }          
            let cart_lineItemId = $(this).attr('data-lineItemId');
            // console.log('cart_lineItemId',cart_lineItemId);          
            $('body').addClass('custom-data-drawer');          
            var cart_image = $(this).closest('.order-outer').find('.CartItem__Image').attr('src');
            // console.log('cart_image',cart_image);          
            var cart_title = $(this).closest('.order-outer').find('.CartItem__Title').text();
            // console.log('cart_title',cart_title);          
            var dr_top_html = "";
            if(cart_image != null && cart_title != null ){
              dr_top_html += `<div class="img">`
              dr_top_html +=   `<img src="${cart_image}">`
              dr_top_html +=  `</div>`
              dr_top_html +=  `<div class="content">`
              dr_top_html +=    `<h5>${cart_title}</h5>`
              dr_top_html +=  `</div>`
              $('.orderItem_content').html(dr_top_html);
            }
            var new_dr_html = '';
            if(cart_lineItemId == cartData_line_itemID){
              console.log("reacipentAttr",reacipentAttr);
              $(reacipentAttr).each(function(index,Items){
                if(Items){
                  var getDateValue = Items.attributeName;
                  if(getDateValue == 'Send on'){
                    // var second_date = moment(Items.values).format('DD-MM-YYYY');
                    var second_date = Items.values
                    new_dr_html += `<li><div class="inner-title"><span>${Items.attributeName}</span> <span style="text-transform: initial !important;">${second_date}</span></div></li>`;
                  }else{
                    new_dr_html += `<li><div class="inner-title"><span>${Items.attributeName}</span> <span style="text-transform: initial !important;">${Items.values}</span></div></li>`;
                  }
                }
              });
              console.log("new_dr_html",new_dr_html);
              $('.style_details').html(new_dr_html);
            }
          });
        });
      }

      // home visit
      if($('.template-order .home_visit_drw').length > 0){
        var dr_htmlHV = '';
        $(order_allData).each(function(index,Items){
          var cartData_line_itemIDHV  = Items.id;
          var cartData_propertiesHV  = Items.properties;
          var newgetgiftdataHV = [];
          var reacipentAttrHV;
          
          $(cartData_propertiesHV).each(function(index,Items){
          newgetgiftdataHV.push({ 'properties_name':Items[0], 'properties_value':Items[1],'item_id':cartData_line_itemIDHV});
          });
          console.log("newgetgiftdataHV",newgetgiftdataHV,"cartData_line_itemIDHV",cartData_line_itemIDHV);
          
          $(newgetgiftdataHV).each(function(index,Items){
            if(Items.properties_name == 'pincode' ){
              reacipentAttrHV = newgetgiftdataHV;
              $('.order_customDatadrawer[data-lineitemid='+cartData_line_itemIDHV+']').removeClass('hide');
              console.log("class removed");
              // var getProductiedValue = Items.properties_value;
              // if(getProductiedValue != '' && getProductiedValue != '[]'){
              //   $('.order_customDatadrawer[data-lineitemid='+cartData_line_itemIDHV+']').removeClass('hide');
              //   var getnewarrydata = getProductiedValue.replaceAll('&quot;','"'); 
              //   reacipentAttrHV = JSON.parse(getnewarrydata);
              // }else{
              //   $('.order_customDatadrawer[data-lineitemid='+cartData_line_itemIDHV+']').addClass('hide');
              // }
            }
          });
          
          $(document).on('click','.home_visit_drw .order_customDatadrawer',function(){
            console.log("order_customDatadrawer 348");
            var cartItem_gift_title = $(this).closest('.order-outer').find('.cust-drw-btn').attr('data-gift-details');
            $('.order-cust-detail .title').find('h3').text('Appointment Details');
            let cart_lineItemId = $(this).attr('data-lineItemId');
            // console.log('cart_lineItemId',cart_lineItemId);          
            $('body').addClass('custom-data-drawer');          
            var cart_image = $(this).closest('.order-outer').find('.CartItem__Image').attr('src');
            // console.log('cart_image',cart_image);          
            var cart_title = $(this).closest('.order-outer').find('.CartItem__Title').text();
            // console.log('cart_title',cart_title);          
            var dr_top_html = "";
            if(cart_image != null && cart_title != null ){
              dr_top_html += `<div class="img">`
              dr_top_html +=   `<img src="${cart_image}">`
              dr_top_html +=  `</div>`
              dr_top_html +=  `<div class="content">`
              dr_top_html +=    `<h5>${cart_title}</h5>`
              dr_top_html +=  `</div>`
              $('.orderItem_content').html(dr_top_html);
            }
            var new_dr_html = '';
            if(cart_lineItemId == cartData_line_itemIDHV){
              console.log("reacipentAttrHV",reacipentAttrHV);
              $(reacipentAttrHV).each(function(index,Items){
                if(Items.properties_name != "_timestamp"){
                  if(Items.properties_name == "pincode"){
                    new_dr_html += `<li><div class="inner-title"><span>Pincode</span> <span style="text-transform: initial !important;">${Items.properties_value}</span></div></li>`;
                  }else if(Items.properties_name == "appointmentDate"){
                    new_dr_html += `<li><div class="inner-title"><span>Appointment Date</span> <span style="text-transform: initial !important;">${Items.properties_value}</span></div></li>`;
                  }else if(Items.properties_name == "appointmentSlot"){
                    new_dr_html += `<li><div class="inner-title"><span>Appointment Slot</span> <span style="text-transform: initial !important;">${Items.properties_value}</span></div></li>`;
                  }
                }
              });
              console.log("new_dr_html",new_dr_html);
              $('.style_details').html(new_dr_html);
            }
          });
        });
      }
      // home visit end
      
      $.ajax({
        url: baseUrlBsc+ '/order-module/v2/getShopiy/ProductStatus/IN-'+order_dataa,
        type: 'GET',
        headers: requestToken,
        dataType: "json",
        success: function(data) {
        console.log('data11',data);
        if(data && data.success){
          $('.order-outer').removeClass('loaderRun');
          var enigmaObj = data.data;
          var item_id = []
          var new_groupedData = {};
          var getIDS = [];
          $(enigmaObj).each(function(index,Items){
            // console.log("Items",Items);
            var line_item_id = Items.line_item_id;
            item_id.push(line_item_id);
            if (new_groupedData[line_item_id] === undefined) {
              new_groupedData[line_item_id] = [Items];
              var newvalue = new_groupedData[line_item_id] = [Items];
              getIDS.push(newvalue)
            } else {
              new_groupedData[line_item_id].push(Items);
            }
          });
          var triallength = 0
          $(getIDS).each(function(index,Items){
            $.each(Items, function (el, value) {
              var thisindex = el;
              var newvalueID = value.line_item_id
              var newvaluestatus = value.status.toLowerCase()
              var newvalueshexCode = value.hexCode
              var newvaluesisTrial = value.isTrial
              var newvaluesisTrialConfirmed = value.isTrialConfirmed
              if(newvaluesisTrial == true && newvaluesisTrialConfirmed == false ){
                if(newvaluestatus == 'shipped' || newvaluestatus == 'delivered' || newvaluestatus == 'ready at store'){
                  var showBtn = 'true';
                  triallength++
                }
              }
              setTimeout(function(){
                if(newvaluesisTrial == true && newvaluesisTrialConfirmed == false ){
                  $(".order_line[data-lineitemid='" + newvalueID + "']").eq(thisindex).find('.fit_confirmed').text('Trial');
                }
                
                if(newvaluesisTrial == true && newvaluesisTrialConfirmed == true ){
                  if(newvaluestatus == 'shipped' || newvaluestatus == 'delivered' || newvaluestatus == 'ready at store'){
                    $(".order_line[data-lineitemid='" + newvalueID + "']").eq(thisindex).find('.fit_confirmed').text('Fit Confirmed');
                  }
                }
                
                $(".order_line[data-lineitemid='" + newvalueID + "']").eq(thisindex).find(".Cart__Shipment").text(newvaluestatus)
                $(".order_line[data-lineitemid='" + newvalueID + "']").eq(thisindex).find(".Cart__Shipment").addClass(newvaluestatus)
                $(".order_line[data-lineitemid='" + newvalueID + "']").eq(thisindex).find(".Cart__Shipment").css("color",newvalueshexCode)
                
                // shiiping date
                let unix_timestamp = value.shippingDate;
                var date = new Date(unix_timestamp);
                var monthName = date.toLocaleString("default", { month: "short" });
                var day = date.getUTCDate();
                var month = date.getUTCMonth() + 1;
                var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']; 
                var weekday_name = weekdays[date.getDay()];
                
                if(day < 10){
                  day = '0'+day;
                }
                if(month < 10){
                  month = '0'+month;
                }
                var formattedLongtime = weekday_name + ", " + day +" "+ monthName;
                var newShipHTML = '';
                newShipHTML += '<div class="ship_new_outer">';
                newShipHTML += '<div class="ship_new">';
                newShipHTML += '<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.98 8.745a.69.69 0 0 0-.056-.222c-.007-.013 0-.028-.012-.042L21.87 4.836c-.329-.585-.92-.944-1.557-.946h-4.138v-.665a3.348 3.348 0 0 0-.883-2.28A2.916 2.916 0 0 0 13.164 0H3.012c-.8 0-1.565.341-2.13.947A3.35 3.35 0 0 0 0 3.229v12.702c0 .367.278.665.62.665h1.927c.19.916.76 1.688 1.548 2.097a2.692 2.692 0 0 0 2.495 0c.789-.409 1.359-1.181 1.548-2.097h8.533c.19.913.76 1.683 1.547 2.09a2.692 2.692 0 0 0 2.491 0c.787-.407 1.357-1.177 1.548-2.09h1.122c.343 0 .621-.298.621-.665V8.838a.713.713 0 0 0-.02-.093zM6.97 15.937c-.003.607-.308 1.166-.8 1.468-.49.301-1.095.3-1.585-.005-.49-.304-.791-.865-.791-1.472 0-.606.301-1.167.791-1.471a1.497 1.497 0 0 1 1.586-.005c.491.302.796.861.799 1.468v.017zm7.965-11.383v10.712H8.141c-.188-.918-.759-1.693-1.548-2.103-.79-.41-1.71-.41-2.5 0s-1.36 1.185-1.548 2.103H1.242V3.229c0-.502.187-.984.518-1.339a1.713 1.713 0 0 1 1.25-.556h10.158c.47 0 .919.2 1.25.556.332.355.519.837.52 1.34l-.004 1.324zm1.242.665h4.138a.57.57 0 0 1 .492.3l1.477 2.64H16.18l-.003-2.94zm3.286 12.451a1.575 1.575 0 0 1-1.145-.511 1.808 1.808 0 0 1-.476-1.228c0-.462.172-.905.477-1.232.305-.326.719-.51 1.15-.51.431 0 .845.184 1.15.511.304.327.476.77.476 1.232 0 .462-.172.905-.477 1.232-.305.326-.718.51-1.15.51l-.005-.004zm3.297-2.404h-.487c-.19-.918-.76-1.692-1.55-2.101-.79-.41-1.71-.41-2.5 0s-1.36 1.183-1.55 2.1h-.492V9.494h6.579v5.773zM11.658 4.484a.69.69 0 0 1 .182.47.69.69 0 0 1-.182.47L7.154 10.25a.6.6 0 0 1-.44.195.6.6 0 0 1-.438-.195L4.569 8.42a.699.699 0 0 1 0-.94.592.592 0 0 1 .878 0l1.268 1.359 4.066-4.356a.592.592 0 0 1 .877.001z" fill="#231F20"/></svg>';
                newShipHTML += '<a href="'+value.trackingUrl+'" target="blank">'+value.message+'</a>';
                newShipHTML += '</div></div>';
                //console.log('formattedLongtime',formattedLongtime);
                if(newvaluestatus == 'pending' || newvaluestatus == 'trial pending' || newvaluestatus == 'delivered' || newvaluestatus == 'alter pending' || newvaluestatus == 'ready at store' || newvaluestatus == 'cancelled' || newvaluestatus == 'refunded' || newvaluestatus == 'return to origin' || newvaluestatus == 'alter cancelled'){
                // $("[data-line-item-id='" + newvalueID + "']").closest('.order_line').find('.MainDeliveryETA').hide().addClass('maindelhide');
                }
                if(newvaluestatus == 'shipped' || newvaluestatus == 'shipped_to_store' || newvaluestatus == 'delivered_to_store' ){
                  $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.ord_not_shipp').addClass('hide');
                  $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.ord_status').removeClass('hide');
                  $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA .ord_status .order-shipped').html(newShipHTML);
                  $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA .promiseText').addClass('shipped_promis');
                }else{
                  $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.ord_not_shipp').removeClass('hide');
                  $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.ord_status').addClass('hide');
                }
                
                var estimatedShipDateHTML = '';
                if(value.message != null){
                  estimatedShipDateHTML += '<div class="shippingETA">';
                  estimatedShipDateHTML += '<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.98 8.745a.69.69 0 0 0-.056-.222c-.007-.013 0-.028-.012-.042L21.87 4.836c-.329-.585-.92-.944-1.557-.946h-4.138v-.665a3.348 3.348 0 0 0-.883-2.28A2.916 2.916 0 0 0 13.164 0H3.012c-.8 0-1.565.341-2.13.947A3.35 3.35 0 0 0 0 3.229v12.702c0 .367.278.665.62.665h1.927c.19.916.76 1.688 1.548 2.097a2.692 2.692 0 0 0 2.495 0c.789-.409 1.359-1.181 1.548-2.097h8.533c.19.913.76 1.683 1.547 2.09a2.692 2.692 0 0 0 2.491 0c.787-.407 1.357-1.177 1.548-2.09h1.122c.343 0 .621-.298.621-.665V8.838a.713.713 0 0 0-.02-.093zM6.97 15.937c-.003.607-.308 1.166-.8 1.468-.49.301-1.095.3-1.585-.005-.49-.304-.791-.865-.791-1.472 0-.606.301-1.167.791-1.471a1.497 1.497 0 0 1 1.586-.005c.491.302.796.861.799 1.468v.017zm7.965-11.383v10.712H8.141c-.188-.918-.759-1.693-1.548-2.103-.79-.41-1.71-.41-2.5 0s-1.36 1.185-1.548 2.103H1.242V3.229c0-.502.187-.984.518-1.339a1.713 1.713 0 0 1 1.25-.556h10.158c.47 0 .919.2 1.25.556.332.355.519.837.52 1.34l-.004 1.324zm1.242.665h4.138a.57.57 0 0 1 .492.3l1.477 2.64H16.18l-.003-2.94zm3.286 12.451a1.575 1.575 0 0 1-1.145-.511 1.808 1.808 0 0 1-.476-1.228c0-.462.172-.905.477-1.232.305-.326.719-.51 1.15-.51.431 0 .845.184 1.15.511.304.327.476.77.476 1.232 0 .462-.172.905-.477 1.232-.305.326-.718.51-1.15.51l-.005-.004zm3.297-2.404h-.487c-.19-.918-.76-1.692-1.55-2.101-.79-.41-1.71-.41-2.5 0s-1.36 1.183-1.55 2.1h-.492V9.494h6.579v5.773zM11.658 4.484a.69.69 0 0 1 .182.47.69.69 0 0 1-.182.47L7.154 10.25a.6.6 0 0 1-.44.195.6.6 0 0 1-.438-.195L4.569 8.42a.699.699 0 0 1 0-.94.592.592 0 0 1 .878 0l1.268 1.359 4.066-4.356a.592.592 0 0 1 .877.001z" fill="#231F20"/></svg>';
                  estimatedShipDateHTML += '</div>';
                  //estimatedShipDateHTML += '<div class="shippingETAtext">Estimated Shipping by <strong>'+formattedLongtime+'</strong></div>'
                  estimatedShipDateHTML += '<div class="shippingETAtext">'+value.message+'</strong></div>';
                  // console.log("lineItem",$("[data-line-item-id='" + newvalueID + "']"));
                }
                // console.log("order_line",$("[data-line-item-id='" + newvalueID + "']").eq(thisindex));
                // $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA .shippingInnerNr').html(estimatedShipDateHTML);
                // $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA').addClass('mainestimate');
                let hideClass = value.message == null ? 'hide' : '';
                if(document.body.clientWidth > 991){
                  $(".pr-show-desk [data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA .shippingInnerNr').html(estimatedShipDateHTML);
                  $(".pr-show-desk [data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA').addClass(`mainestimate ${hideClass}`);
                }else{
                  $(".pr-show-mob [data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA .shippingInnerNr').html(estimatedShipDateHTML);
                  $(".pr-show-mob [data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA').addClass(`mainestimate ${hideClass}`);
                }
                $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA').addClass('mainestimate');
                
                // $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find(".order-eta .delay-text").html("Order delayed.");
                if(document.body.clientWidth > 991){
                  $(".pr-show-desk [data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find(".order-eta p").html(value.message);
                  // console.log("div>>>>>>>>",$(".pr-show-desk [data-line-item-id='" + newvalueID + "']"));
                }else{
                  $(".pr-show-mob [data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find(".order-eta p").html(value.message);
                  // console.log("div>>>>>>>>",$(".pr-show-mob [data-line-item-id='" + newvalueID + "']"));
                }
                // endof shippind date
                
                var now = new Date();
                
                if(now.getTime() > date.getTime()){ 
                  $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA .ord_not_shipp .promiseText').removeClass('hide');
                  $("[data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA').addClass('removemian');
                }
                
              },100);
            });
          }); 
          
          setTimeout(function(){
          if(triallength >= 1)
          {
          $('.confirmed_fit').show();
          $(".Customer_HeadRight").addClass("cf-d-none");
          }
          else
          {
          $('.confirmed_fit').hide();
          $(".Customer_HeadRight").removeClass("cf-d-none");
          }
          },100);
          
          const mergeArrays = (lineItemArr = [], enigmaObj = []) => {
          let res = [];
          res = lineItemArr.map(obj => {
          const index = enigmaObj.findIndex(el => el["line_item_id"] == obj["line_item_id"]);
          const { id } = index !== -1 ? enigmaObj[index] : {};
          const { isTrial } = index !== -1 ? enigmaObj[index] : {};
          const { isTrialConfirmed } = index !== -1 ? enigmaObj[index] : {};
          const { shippingDate } = index !== -1 ? enigmaObj[index] : {};
          const { status } = index !== -1 ? enigmaObj[index] : {};
          return {
          ...obj,
          id,
          isTrial,
          isTrialConfirmed,
          shippingDate,
          status
          };
          });
          return res;
          };
          
          //console.log('mergeArrays-',mergeArrays(lineItemArr, enigmaObj));
          
          let lineItemenigma = mergeArrays(lineItemArr, enigmaObj);
          for(var i = 0;i < lineItemenigma.length;i++){
          var items = lineItemenigma[i];
          var item_status = items.status.toLowerCase();
          var isTrial = items.isTrial;
          var isTrialConfirmed = items.isTrialConfirmed;
          
          if(isTrial == true && isTrialConfirmed == false )
          {
          if(item_status == 'shipped' || item_status == 'delivered' || item_status == 'ready at store')
          {
          var showBtn = 'true';
          }
          }
          
          if(isTrial == true && isTrialConfirmed == false )
          {
          $(".order_line[data-lineitemid='" + items.line_item_id + "']").find('.fit_confirmed').text('Trial');
          }
          
          if(isTrial == true && isTrialConfirmed == true )
          {
          if(item_status == 'shipped' || item_status == 'delivered' || item_status == 'ready at store')
          {
          $(".order_line[data-lineitemid='" + items.line_item_id + "']").find('.fit_confirmed').text('Fit Confirmed');
          }
          }
          }
          //console.log('showBtn-',showBtn);
          if(showBtn == 'true')
          {
          $('.confirmed_fit').show();
          $(".Customer_HeadRight").addClass("cf-d-none");
          }
          else
          {
          $('.confirmed_fit').hide();
          $(".Customer_HeadRight").removeClass("cf-d-none");
          }
          
          
          $('.confirmed_fit').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true,
          callbacks: {
          open: function() {
          $('html').addClass('Popup_Open');
          
          
          var lineItem_html = "";
          var itemLength = 0;
          console.log("lineItemenigma",lineItemenigma);
          for(var i = 0;i < lineItemenigma.length;i++)
          {
          var items = lineItemenigma[i];
          var item_status = items.status.toLowerCase();
          var isTrial = items.isTrial;
          var isTrialConfirmed = items.isTrialConfirmed;
          
          if(isTrial == true && isTrialConfirmed == false)
          {  
          if(item_status == 'shipped' || item_status == 'delivered' || item_status == 'ready at store')
          { 
          lineItem_html += "<div class='lineItemContainer'>";                   
          lineItem_html += "<input type='checkbox' id='confirmFit_check' name='confirmFit_check' value='"+ items.line_item_id +"'>"; 
          lineItem_html += "<div class='lineItemImg'>";
          lineItem_html += "<img class='CartItem_image' src='"+items.url+"'>";   
          lineItem_html += "</div>";
          lineItem_html += "<div class='lineItemContent'>";
          // lineItem_html += "<div class='CartItem_vender'>"+items.vender+"</div>";
          lineItem_html += " <h2 class='CartItem_title'>"+items.title+"</h2>";
          lineItem_html += "<span class='CartItem_price'>"+items.final_price+"</span>";
          lineItem_html += "</div>";
          lineItem_html += "</div>";  
          var itemLength = itemLength + 1 ;
          }
          }
          
          }
          
          var enigmaObj = data.data;
          var item_id = []
          var new_groupedData = {};
          var getIDS = [];
          var lineItem_html = "";
          var itemLength = 0;
          $(enigmaObj).each(function(index,Items){
          var line_item_id = Items.line_item_id;
          item_id.push(line_item_id);
          if (new_groupedData[line_item_id] === undefined) {
          new_groupedData[line_item_id] = [Items];
          var newvalue = new_groupedData[line_item_id] = [Items];
          getIDS.push(newvalue)
          } else {
          new_groupedData[line_item_id].push(Items);
          }
          });
          $(getIDS).each(function(index,Items){
          $.each(Items, function (el, line_items) {
          var line_item = line_items;
          var line_item_id = line_items.line_item_id;
          var item_status = line_item.status.toLowerCase();
          var isTrial = line_item.isTrial;
          var isTrialConfirmed = line_item.isTrialConfirmed;
          if(isTrial == true && isTrialConfirmed == false)
          {  
          if(item_status == 'shipped' || item_status == 'delivered' || item_status == 'ready at store')
          {
          var itemLength = itemLength + 1 ;
          var item_value = [];
          $.each(lineItemenigma, function (el, line_items) {
          if(line_item_id == line_items.line_item_id){
          item_value.push(line_items);
          }
          });
          lineItem_html += "<div class='lineItemContainer'>";                   
          lineItem_html += "<input type='checkbox' id='confirmFit_check' name='confirmFit_check' value='"+ item_value[el].line_item_id +"'>"; 
          lineItem_html += "<div class='lineItemImg'>";
          lineItem_html += "<img class='CartItem_image' src='"+item_value[el].url+"'>";   
          lineItem_html += "</div>";
          lineItem_html += "<div class='lineItemContent'>";
          // lineItem_html += "<div class='CartItem_vender'>"+item_value[el].vender+"</div>";
          lineItem_html += " <h2 class='CartItem_title'>"+item_value[el].title+"</h2>";
          lineItem_html += "<span class='CartItem_price'>"+item_value[el].final_price+"</span>";
          lineItem_html += "</div>";
          lineItem_html += "</div>";  
          
          }
          }
          })
          })
          
          $('.lineItemContainer').html(lineItem_html);
          var item_length = $('.lineItemContainer').length-1;
          var confirmBtn_html = "<a href='javascript:void(0);' class='ConfirmFit_btn Button Button--primary btn_disable'>Confirm fit (<span>0</span> of "+ item_length +" products)</a>";
          $(".lineItemButton").html(confirmBtn_html);
          
          var checkValueArr = [];
          var $checkboxes = $('input[type="checkbox"]');
          $checkboxes.change(function(){
          var countCheckedCheckboxes = $checkboxes.filter(':checked').length;
          $('.ConfirmFit_btn span').text(countCheckedCheckboxes);
          var checkdValue = $(this).val();
          
          if ($(this).is(':checked')) {
          checkValueArr.push(checkdValue);
          }else{
          checkValueArr.splice($.inArray(checkdValue, checkValueArr),1);
          }
          
          var checkedLength = checkValueArr.length;
          //console.log('checkedLength-',checkedLength); 
          if (checkedLength == 0 )
          {
          $('.ConfirmFit_btn').addClass('btn_disable');
          }
          else
          {
          $('.ConfirmFit_btn').removeClass('btn_disable');
          }
          
          }); 
          
          
          $('.ConfirmFit_btn').click(function(){
          //$.magnificPopup.close();
          //console.log('checkValueArr-',checkValueArr);
          
          
          $.each(checkValueArr, function(index, line_item_id){
          $(".AccountTable .order_line[data-lineitemid='" + line_item_id + "']").find('.fit_confirmed').text('Fit Confirmed');
          });
          
          var passValueArr = [];
          for(var i = 0;i < lineItemenigma.length;i++){
          var items=lineItemenigma[i];
          if(jQuery.inArray(items.line_item_id, checkValueArr) > -1)
          {
          passValueArr.push(items.id);
          }
          }    
          
          //console.log('passValueArr-',passValueArr);
          
          $.ajax({
          url: baseUrlBsc+'/order-module/order-product/confirmTrial?remoteOrderNumber=IND-'+order_number,
          async: false,
          type: 'PUT',
          data: JSON.stringify(passValueArr),
          contentType: "application/json",
          dataType: "json",
          headers: requestToken,
          success: function(data) {
          console.log('success');
          },
          error: function(err) {
          }
          });
          
          $.magnificPopup.open({
          items: {
          src: '<div class="confirmed-message Popup Popup__Small"><img src="https://cdn.shopify.com/s/files/1/0536/3594/0515/files/rightArrow.png?v=1646893514" alt="checkmark image" class="checkmark-icon"><p>Fit for '+checkValueArr.length+' of '+ item_length +' products is confirmed <br/> successfully</p><button title="Close" type="button" onClick="window.location.reload();" class="mfp-close"><svg version="1.1" class="Icon Icon--Back" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21.061px" height="21.061px" viewBox="0 0 21.061 21.061" enable-background="new 0 0 21.061 21.061" xml:space="preserve"><line fill="none" stroke="#231f20" stroke-width="1.5" stroke-miterlimit="10" x1="0.266" y1="20.795" x2="20.795" y2="0.265"></line><line fill="none" stroke="#231f20" stroke-width="1.5" stroke-miterlimit="10" x1="20.795" y1="20.795" x2="0.265" y2="0.265"></line></svg></button><a onclick="window.location.reload();" class="close-successfully-popup Button Button--primary Button--full">Continue</a></div>'
          },
          type:'inline',
          midClick: true
          });
          
          }); 
          
          
          },
          close: function(){
          $('html').removeClass('Popup_Open');
          }
          }
          });
          $('#confirmedfit_popup .Popup__Dismiss').click(function(){
          $.magnificPopup.close();
          
          })        
          
          for(var i = 0;i < data.data.length;i++){
          items=data.data[i];
          line_item_id=items.line_item_id;
          item_status=items.status;
          item_color=items.hexCode;
          data_line_item_id= $("[data-line-item-id='" + line_item_id + "']");
          data_line_item_id.text(items.status).addClass(items.status);
          data_line_item_id.css("color", item_color);
          var item_status = items.status.toLowerCase();
          
          
          // shiiping date
          let unix_timestamp = items.shippingDate;
          var date = new Date(unix_timestamp);
          var monthName = date.toLocaleString("default", { month: "short" });
          var day = date.getUTCDate();
          var month = date.getUTCMonth() + 1;
          var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']; 
          var weekday_name = weekdays[date.getDay()];
          
          if(day < 10){
          day = '0'+day
          }
          if(month < 10){
          month = '0'+month
          }
          var formattedLongtime = weekday_name + ", " + day +" "+ monthName;
          var newShipHTML = '';
          newShipHTML += '<div class="ship_new_outer">';
          newShipHTML += '<div class="ship_new">';
          newShipHTML += '<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.98 8.745a.69.69 0 0 0-.056-.222c-.007-.013 0-.028-.012-.042L21.87 4.836c-.329-.585-.92-.944-1.557-.946h-4.138v-.665a3.348 3.348 0 0 0-.883-2.28A2.916 2.916 0 0 0 13.164 0H3.012c-.8 0-1.565.341-2.13.947A3.35 3.35 0 0 0 0 3.229v12.702c0 .367.278.665.62.665h1.927c.19.916.76 1.688 1.548 2.097a2.692 2.692 0 0 0 2.495 0c.789-.409 1.359-1.181 1.548-2.097h8.533c.19.913.76 1.683 1.547 2.09a2.692 2.692 0 0 0 2.491 0c.787-.407 1.357-1.177 1.548-2.09h1.122c.343 0 .621-.298.621-.665V8.838a.713.713 0 0 0-.02-.093zM6.97 15.937c-.003.607-.308 1.166-.8 1.468-.49.301-1.095.3-1.585-.005-.49-.304-.791-.865-.791-1.472 0-.606.301-1.167.791-1.471a1.497 1.497 0 0 1 1.586-.005c.491.302.796.861.799 1.468v.017zm7.965-11.383v10.712H8.141c-.188-.918-.759-1.693-1.548-2.103-.79-.41-1.71-.41-2.5 0s-1.36 1.185-1.548 2.103H1.242V3.229c0-.502.187-.984.518-1.339a1.713 1.713 0 0 1 1.25-.556h10.158c.47 0 .919.2 1.25.556.332.355.519.837.52 1.34l-.004 1.324zm1.242.665h4.138a.57.57 0 0 1 .492.3l1.477 2.64H16.18l-.003-2.94zm3.286 12.451a1.575 1.575 0 0 1-1.145-.511 1.808 1.808 0 0 1-.476-1.228c0-.462.172-.905.477-1.232.305-.326.719-.51 1.15-.51.431 0 .845.184 1.15.511.304.327.476.77.476 1.232 0 .462-.172.905-.477 1.232-.305.326-.718.51-1.15.51l-.005-.004zm3.297-2.404h-.487c-.19-.918-.76-1.692-1.55-2.101-.79-.41-1.71-.41-2.5 0s-1.36 1.183-1.55 2.1h-.492V9.494h6.579v5.773zM11.658 4.484a.69.69 0 0 1 .182.47.69.69 0 0 1-.182.47L7.154 10.25a.6.6 0 0 1-.44.195.6.6 0 0 1-.438-.195L4.569 8.42a.699.699 0 0 1 0-.94.592.592 0 0 1 .878 0l1.268 1.359 4.066-4.356a.592.592 0 0 1 .877.001z" fill="#231F20"/></svg>';
          // newShipHTML += '<a href="'+items.trackingUrl+'" target="blank">'+items.message+'</a>';
          newShipHTML += items.message;
          newShipHTML += '</div></div>';
          //console.log('formattedLongtime',formattedLongtime);
          if(item_status == 'pending' || item_status == 'trial pending' || item_status == 'delivered' || item_status == 'alter pending' || item_status == 'ready at store' || item_status == 'cancelled' || item_status == 'refunded' || item_status == 'return to origin' || item_status == 'alter cancelled'){
          // $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.MainDeliveryETA').hide().addClass('maindelhide');
          // // $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find(".order-eta .delay-text").hide();
          // if(document.body.clientWidth > 991){
          //   $(".pr-show-desk [data-line-item-id='" + newvalueID + "']").closest('.order_line').find('.MainDeliveryETA').hide().addClass('maindelhide');
          //   // $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.MainDeliveryETA').hide().addClass('maindelhide');
          // }else{
          //   console.log("mainETA>>>>>>>>>>>",$(".pr-show-mob [data-line-item-id='" + newvalueID + "']").eq(thisindex).closest('.order_line').find('.MainDeliveryETA'));
          //   $(".pr-show-mob [data-line-item-id='" + newvalueID + "']").eq(i).closest('.order_line').find('.MainDeliveryETA').hide().addClass('maindelhide');
          // }
          }  
          if(item_status == 'shipped' || item_status == 'shipped_to_store' || item_status == 'delivered_to_store' ){
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.ord_not_shipp').addClass('hide');
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.ord_status').removeClass('hide');
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.MainDeliveryETA .ord_status .order-shipped').html(newShipHTML);
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.MainDeliveryETA .promiseText').addClass('shipped_promis');
          }
          
          var estimatedShipDateHTML = '';
          estimatedShipDateHTML += '<div class="shippingETA">';
          estimatedShipDateHTML += '<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.98 8.745a.69.69 0 0 0-.056-.222c-.007-.013 0-.028-.012-.042L21.87 4.836c-.329-.585-.92-.944-1.557-.946h-4.138v-.665a3.348 3.348 0 0 0-.883-2.28A2.916 2.916 0 0 0 13.164 0H3.012c-.8 0-1.565.341-2.13.947A3.35 3.35 0 0 0 0 3.229v12.702c0 .367.278.665.62.665h1.927c.19.916.76 1.688 1.548 2.097a2.692 2.692 0 0 0 2.495 0c.789-.409 1.359-1.181 1.548-2.097h8.533c.19.913.76 1.683 1.547 2.09a2.692 2.692 0 0 0 2.491 0c.787-.407 1.357-1.177 1.548-2.09h1.122c.343 0 .621-.298.621-.665V8.838a.713.713 0 0 0-.02-.093zM6.97 15.937c-.003.607-.308 1.166-.8 1.468-.49.301-1.095.3-1.585-.005-.49-.304-.791-.865-.791-1.472 0-.606.301-1.167.791-1.471a1.497 1.497 0 0 1 1.586-.005c.491.302.796.861.799 1.468v.017zm7.965-11.383v10.712H8.141c-.188-.918-.759-1.693-1.548-2.103-.79-.41-1.71-.41-2.5 0s-1.36 1.185-1.548 2.103H1.242V3.229c0-.502.187-.984.518-1.339a1.713 1.713 0 0 1 1.25-.556h10.158c.47 0 .919.2 1.25.556.332.355.519.837.52 1.34l-.004 1.324zm1.242.665h4.138a.57.57 0 0 1 .492.3l1.477 2.64H16.18l-.003-2.94zm3.286 12.451a1.575 1.575 0 0 1-1.145-.511 1.808 1.808 0 0 1-.476-1.228c0-.462.172-.905.477-1.232.305-.326.719-.51 1.15-.51.431 0 .845.184 1.15.511.304.327.476.77.476 1.232 0 .462-.172.905-.477 1.232-.305.326-.718.51-1.15.51l-.005-.004zm3.297-2.404h-.487c-.19-.918-.76-1.692-1.55-2.101-.79-.41-1.71-.41-2.5 0s-1.36 1.183-1.55 2.1h-.492V9.494h6.579v5.773zM11.658 4.484a.69.69 0 0 1 .182.47.69.69 0 0 1-.182.47L7.154 10.25a.6.6 0 0 1-.44.195.6.6 0 0 1-.438-.195L4.569 8.42a.699.699 0 0 1 0-.94.592.592 0 0 1 .878 0l1.268 1.359 4.066-4.356a.592.592 0 0 1 .877.001z" fill="#231F20"/></svg>';
          estimatedShipDateHTML += '</div>';
          //estimatedShipDateHTML += '<div class="shippingETAtext">Estimated Shipping by <strong>'+formattedLongtime+'</strong></div>'
          estimatedShipDateHTML += '<div class="shippingETAtext">'+items.message+'</strong></div>'
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.MainDeliveryETA .shippingInnerNr').html(estimatedShipDateHTML);
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.MainDeliveryETA').addClass('mainestimate');
          // $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find(".order-eta .delay-text").html("Order delayed.");
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find(".order-eta p").html(items.message);
          // endof shippind date
          
          var now = new Date();
          
          if(now.getTime() > date.getTime())
          { 
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.MainDeliveryETA .ord_not_shipp .promiseText').removeClass('hide');
          $("[data-line-item-id='" + line_item_id + "']").closest('.order_line').find('.MainDeliveryETA').addClass('removemian');
          }
          
          }
          //start edit customization
          if(data.data.length){
          $( data.data ).each(function(i) {
          var cartData_line_item_id  = data.data[i].line_item_id;
          // console.log('cartData_line_item_id',data.data[i].customizedAttributes);
          if(data.data[i].customizedAttributes != null ){
          if( data.data[i].customizedAttributes.length ){ 
          $('.order_customDatadrawer[data-lineitemid='+cartData_line_item_id+']').removeClass('hide');
          //$('.order_customDatadrawer[data-lineitemid='+cartData_line_item_id+']').hide();
          }else{
          $('.order_customDatadrawer[data-lineitemid='+cartData_line_item_id+']').addClass('hide');
          }
          }else{
            console.log("nulll atttttrrrrrr",data.data[i]); // "BOMHV"
            if(data.data[i].sku != "BOMHV"){
              $('.order_customDatadrawer[data-lineitemid='+cartData_line_item_id+']').addClass('hide');
            }
          }
          
          })
          }
          //  else{
          //   $('.order-bottom-main .order_customDatadrawer').hide();
          // }
          // Start - Button click to Drawer open 
          $(document).on('click','.order_customDatadrawer',function(){
            console.log("order_customDatadrawer 815");
            
            let cart_lineItemId = $(this).attr('data-lineItemId');
            console.log('cart_lineItemId',cart_lineItemId);            
            $('body').addClass('custom-data-drawer');            
            var cart_image = $(this).closest('.order-outer').find('.CartItem__Image').attr('src');
            console.log('cart_image',cart_image);            
            var cart_title = $(this).closest('.order-outer').find('.CartItem__Title').text();
            console.log('cart_title',cart_title);            
            var dr_top_html = "";
            if(cart_image != null && cart_title != null ){
              dr_top_html += `<div class="img">`
              dr_top_html +=   `<img src="${cart_image}">`
              dr_top_html +=  `</div>`
              dr_top_html +=  `<div class="content">`
              dr_top_html +=    `<h5>${cart_title}</h5>`
              dr_top_html +=  `</div>`
              $('.orderItem_content').html(dr_top_html);
            }            
            if(data.data.length){            
              $( data.data ).each(function(i) {
                var cartData_line_item_id  = data.data[i].line_item_id;
                //console.log('cartData_line_item_id',cartData_line_item_id);                
                getCustomData =data.data[i].customizedAttributes;                
                //console.log('getCustomData', getCustomData);
                var sleeveFlag = 0;
                if(getCustomData){
                  var editSleeves = jQuery.grep(getCustomData, function(n, i){
                  return (n !== "" && n != null && n.attributeName == 'Sleeves')
                  });
                  if(editSleeves[0]){
                  var editSleeves1 = getParameterByName('imageValue',editSleeves[0]['values']);
                  if(editSleeves1 == 'Short Sleeves'){
                  sleeveFlag = 1;
                  }
                  }
                  var editMonogram = jQuery.grep(getCustomData, function(n, i){
                  return (n !== "" && n != null && n.attributeName == 'Monogram')
                  });
                  
                  if(editMonogram[0]){
                  var editMono = editMonogram[0]['values'][0];
                  editMono = editMono.toLowerCase()
                  }
                  console.log('editMono',editMono);
                  // if(getCustomData[28]){
                  //  var editMono = getCustomData[28]['values'][0];
                  //  console.log('editMono',editMono);
                  // }
                  if (cartData_line_item_id == cart_lineItemId && getCustomData != null)
                  {  
                  
                  let arr = jQuery.grep(getCustomData, function(n, i){
                  return (n !== "" && n != null);
                  });
                  console.log('arr-',arr);
                  
                  var dr_html = "";
                  $.each(arr, function(index, value) {
                  var attrName = value.attributeName;
                  var attrValue = value.values[0];
                  var imgVal = getParameterByName('imageTitle',attrValue);
                  var imagePath = attrValue.split("?");
                  
                  if (attrName.indexOf('Cuff') > -1  && sleeveFlag == 1) {
                  return;
                  }
                  // console.log('attrName--',attrName);
                  // console.log('attrValue--',getParameterByName('imageValue',attrValue));
                  // console.log('img--',imagePath[0]);
                  if(attrName != null && imgVal != null && imagePath[0] != null ){
                  dr_html += `<li><div class="inner-title"><span>${attrName}</span> <span>${imgVal}</span></div><div class="img-right"><img src="${imagePath[0]}"></div> </li>`
                  }else if(attrName == 'Monogram'){
                  if(editMono ){
                  if(editMono == 'leftcuff'){
                  monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/leftcuff.svg';
                  }else if(editMono == 'collar'){
                  monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/collar.svg';
                  }else if(editMono == 'rib'){
                  monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/rib.svg';
                  }else if(editMono == 'pocket'){
                  monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/pocket.svg';
                  }else if(editMono == 'chest'){
                  monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/chest.svg';
                  }
                  dr_html += `<li><div class="inner-title"><span>${attrName}</span> <span>${editMono}</span></div><div class="img-right"><img src="${monoImg}"></div></li>`
                  }
                  
                  }
                  
                  
                  })
                  //console.log('dr_html',dr_html)
                  $('.style_details').html(dr_html);
                  }
                }
              });
            }
          });  
          // End - Button click to Drawer open  
        }else{
          // $('.order-bottom-main .CartItem__Shipment.Item_order_status').hide();
          $('.order-bottom-main .CartItem__Shipment.Item_order_status').addClass("status-blank");
        }
        },
        error: function(err) {
        console.log('err',err);
        }
      });
    }
  }
});


var bsc_sizeJson = {
  "athletic": 
  {xs:"39-39-39,34-35-36,17-17-17.5",s:"41-41-41,36-37-38,17.5-17.5-18",m:"43-43-43,38-39-40,18-18-18.5",l:"46-46-46,42-43-44,18.5-18.5-19",xl:"48-48-48,44-45-46,19-19-19.5"},
  "average": 
  {xs:"39-39-39,36-37-38,16.5-16.5-17",s:"41-41-41,38-39-40,17-17-17.5",m:"44-44-44,41-42-43,18-18-18.5",l:"47-47-47,44-45-46,18.5-18.5-19",xl:"50-50-50,47-48-49,19.5-19.5-20",xxl:"53-53-53,50-51-52,20-20-20.5",xxxl:"56-56-56,53-54-55,21-21-21.5"},
  "healthy": 
  {m:"44-44-44,43-44-45,18-18-18.5",l:"47-47-47,47-48-49,18.5-18.5-19",xl:"50-50-50,50-51-52,19.5-19.5-20",xxl:"54-54-54,55-56-57,21-21-21.5",xxxl:"58-58-58,59-60-61,22-22-22.5",'4xl':"62-62-62,63-64-65,21.5-21.5-22",'5xl':"66-66-66,67-68-69,22-22-22.5",'6xl':"70-70-70,71-72-73,22.5-22.5-23",'7xl':"74-74-74,75-76-77,23-23-23.5"}
}

var bsc_sizeJsonCM = {
  "athletic": 
  {xs:"99.0-99.0-99.0,86.5-89.0-91.5,43.0-43.0-44.5",s:"104.0-104.0-104.0,91.5-94.0-96.5,44.5-44.5-45.5",m:"109.0-109.0-109.0,96.5-99.0-101.5,45.5-45.5-47.0",l:"117.0-117.0-117.0,106.5-109.0-111.5,47.0-47.0-48.5",xl:"122.0-122.0-122.0,111.5-114.5-117.0,48.5-48.5-49.5"},
  "average": 
  {xs:"99.0-99.0-99.0,91.5-94.0-96.5,42.0-42.0-43.0",s:"104.0-104.0-104.0,96.5-99.0-101.5,43.0-43.0-44.5",m:"111.5-111.5-111.5,104.0-106.5-109.0,45.5-45.5-47.0",l:"119.5-119.5-119.5,111.5-114.5-117.0,47.0-47.0-48.0",xl:"127.0-127.0-127.0,119.5-122.0-124.5,49.5-49.5-51.0",xxl:"134.6-134.6-134.6,127.0-129.5-132.0,50.8-50.8-52.0",xxxl:"142.2-142.2-142.2,134.6-137.1-139.7,53.3-53.3-54.6"},
  "healthy": 
  {m:"111.5-111.5-111.5,109.0-111.5-114.5,45.5-45.5-47.0",l:"119.5-119.5-119.5,119.5-122.0-124.5,47.0-47.0-48.0",xl:"127.0-127.0-127.0,127.0-129.5-132.0,49.5-49.5-51.0",xxl:"137.0-137.0-137.0,139.5-142.5-145.0,53.5-53.5-54.5",xxxl:"147.5-147.5-147.5,149.5-152.5-155.0,56.0-56.0-57.0",'4xl':"157.5-157.5-157.5,162.6-162.6-165,54.6-54.6-55.8",'5xl':"167.6-167.6-167.6,172.7-172.7-175.2,55.8-55.8-57.1",'6xl':"117.8-117.8-117.8,182.9-182.9-185.4,57.1-57.1-58.4",'7xl':"187.9-187.9-187.9,193.1-193.1-195.6,58.4-58.4-59.7"}
}

function tableUpdate(activeTable,sizeValue,hasMeasure){
  // console.log('activeTable',activeTable);
  // console.log('sizeValue',sizeValue);
  // console.log('hasMeasure',hasMeasure);
  
  /*-- UPDATE BY UK --*/
  if($(`#product-fit-guide .product-sizechart-tab.tab-fit-guide .sizechart-inch-cm-checkbox:checked`).length > 0){
    hasMeasure = "cm";
  } else {
    hasMeasure = "in";
  }
  /*-- UPDATE BY UK --*/
  
  $('.ProductSize__ChartTable.fit-guide table').addClass('hide'); // update sanjay
  $('.ProductSize__ChartTable table.'+activeTable).removeClass('hide');
  if(hasMeasure == 'in'){    
   var sizeChartArray = bsc_sizeJson[activeTable][sizeValue] ? bsc_sizeJson[activeTable][sizeValue].split(',') : null;
    // console.log('sizeChartArray',sizeChartArray);
  }else{
  var sizeChartArray = bsc_sizeJsonCM[activeTable][sizeValue] ? bsc_sizeJsonCM[activeTable][sizeValue].split(',') : null;
    // console.log('sizeChartArray',sizeChartArray);
  }
  if(sizeChartArray != undefined && sizeChartArray != null){
    var firstRaw = sizeChartArray[0].split('-');
    var secondRaw = sizeChartArray[1].split('-');
    var thirdRaw = sizeChartArray[2].split('-');
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(0) td:eq(0)').text(firstRaw[0]);
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(0) td:eq(1)').text(firstRaw[1]);
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(0) td:eq(2)').text(firstRaw[2]);
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(1) td:eq(0)').text(secondRaw[0]);
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(1) td:eq(1)').text(secondRaw[1]);
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(1) td:eq(2)').text(secondRaw[2]);
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(2) td:eq(0)').text(thirdRaw[0]);
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(2) td:eq(1)').text(thirdRaw[1]);
    $('.ProductSize__ChartTable table.'+activeTable).find('tbody tr:eq(2) td:eq(2)').text(thirdRaw[2]);
  }
}

function draggableTable(slider){
  let isDown = false;
  let startX;
  let scrollLeft;
  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  });
}

// let sliderTabs = document.querySelectorAll(`.pro-measuring-tips-tabs`);
// if(sliderTabs.length > 0){
//   sliderTabs.forEach(sliderEle => {
//     if(sliderEle.querySelectorAll("button").length > 5){
//       draggableTable(sliderEle);
//     }
//   });
// }
// let pf_fitTips = document.querySelector(`.preferredfit-item-list`);
// if(pf_fitTips){
//   draggableTable(pf_fitTips);
// }


// let sizeGuideTables = document.querySelectorAll(".pro-sizechart-table-main table.shirtsize_inch, .pro-sizechart-table-main table.shirtsize_cm");
// if(sizeGuideTables.length > 0){
//   sizeGuideTables.forEach(sliderEle => {
//     if(sliderEle.querySelectorAll("thead th").length > 2){
//       // console.log("size guide sliderEle",sliderEle);
//       draggableTable(sliderEle.closest(".ProductSize__ChartTable"));
//     }
//   });
// }

var animat = 500;
if($(window).width() > 640 ){
  animat = 0;
}  
if($(window).width() <1008){
  $('.Product__SlideItem--image img').click(function(){  $('[data-action="open-product-zoom"]').click(); });
}

$(document).on('click', '.Product__SlideshowNavImage', function (e){
  var mediaID = $(this).attr('data-media-id');
  var el = $('.Product__Slideshow').find(`[data-media-id='${mediaID}']`);
  $('html, body').animate({
    'scrollTop' : el.position().top
  });
});

// order page AWB no. copy btn click event
$(document).on("click",".order-outer .copy_track",function(e){
  e.preventDefault();
  let text = $(this).parent().find("a:not(:empty)").text();
  navigator.clipboard.writeText(text);
  $(this).addClass("copied");
  setTimeout(() => {
    $(this).removeClass("copied");
  },2000);
});